import { Chip, ChipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { TsrctDemandProcessStatus, TsrctDemandStatus } from '@/generated/gql/graphql';

export type DemandProcessStatusUnion = `${TsrctDemandProcessStatus}`;

const propsByStatusMap: {
  [key in DemandProcessStatusUnion]: { color: ChipProps['color'] };
} = {
  [TsrctDemandProcessStatus.OPEN]: { color: 'default' },
  [TsrctDemandProcessStatus.IN_PROGRESS]: { color: 'primary' },
  [TsrctDemandProcessStatus.COMPLETED]: { color: 'success' },
  [TsrctDemandProcessStatus.CANCELLED]: { color: 'default' },
};

export interface DemandProcessStatusChipProps {
  className?: string;
  processStatus?: Union.Nullable<DemandProcessStatusUnion>;
  status?: TsrctDemandStatus;
}

export const DemandProcessStatusChip = ({ className, processStatus, status }: DemandProcessStatusChipProps) => {
  const { t } = useTranslation();

  if (processStatus) {
    const { color } = propsByStatusMap[processStatus];

    return (
      <Chip
        className={className}
        label={t(`DemandProcessStatus.${processStatus}`)}
        color={color}
        data-intercom-target="Demand/StatusChip"
        data-testid="Demand/StatusChip"
        title={status ? t(`DemandStatus.${status}`) : undefined}
      />
    );
  }

  return null;
};
